import {capa} from '../services'
import {fetch as fetchRaw} from '@lib/fetch'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([capa.url, url], ...args)

export function getTasks(queryParams) {
  return fetch(`/v1/actions/?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function getTask(id) {
  return fetch(`/v1/actions/${id}`, {
    method: 'GET',
  })
}

export function createTask(body) {
  return fetch(`/v1/actions/`, {method: 'POST', body: JSON.stringify(body)})
}

export function bulkCreate(items) {
  return fetch(`/v1/actions/bulk-create`, {method: 'POST', body: JSON.stringify(items)})
}

export function patchTask(id, body) {
  return fetch(`/v1/actions/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function deleteTask(id) {
  return Promise.resolve({status: 200})
}

export function archiveTask(body) {
  return fetch(`/v1/actions`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  })
}

export function unarchiveTasks(body) {
  return fetch(`/v1/actions/unarchive`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function createTaskComment(body) {
  return fetch(`/v1/actions/${body?.actionId}/comments`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function deleteTaskComment(body) {
  return fetch(`/v1/actions/${body?.actionId}/comments/${body?.commentId}`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  })
}

export function getTaskComments(id, queryParams) {
  return fetch(`/v1/actions/${id}/comments?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function patchTaskComment(body) {
  return fetch(`/v1/actions/${body?.actionId}/comments/${body?.commentId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function getTaskCommentsStats(id) {
  return fetch(`/v1/actions/${id}/comments-stats`, {
    method: 'GET',
  })
}

export function getTaskStats(id) {
  return fetch(`/v1/actions/${id}/stats`, {
    method: 'GET',
  })
}

export function getCapaHistories(actionId, queryParams) {
  return fetch(`/v1/actions/${actionId}/histories?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function createFull(body) {
  return fetch('/v1/actions/full', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getAuditFindings(auditId, queryParams) {
  return fetch(`/v1/findings/audit/${auditId}/list?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function actionsExport(body) {
  return fetch('/v1/actions/export', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
